e360.controller('AdvSearchController', [
   '$scope',
   '$uibModal',
   'advSearchApi',
   'campaignsApi',
   'surveyItemsApi',
   'utils',
   'dialogs',
   'session',
   'toast',
   'loader',
   'titleService',

   function ($scope, $modal, advSearchApi, campaignsApi, surveyItemsApi, utils, dialogs, session, toast, loader, titleService) {
      titleService.setTitle('Advanced Search');

      var locals = {
         init: function () {
            $scope.page = 1;
            $scope.limit = 20;

            $scope.sources = {
               participant: {
                  value: 'Participant',
                  didNotPreReg: false,
                  selected: false
               },
               prereg: {
                  value: 'PreRegistration',
                  didAttend: null,
                  selected: false
               },
               invitee: {
                  value: 'Invitee',
                  didNotRsvp: false,
                  selected: false
               },
               prospect: {
                  value: 'Prospect',
                  selected: false
               }
            };

            $scope.records = [];
            $scope.loader = loader;
            $scope.surveyFilters = [];
            $scope.showCreateInviteesPanel = false;
            $scope.kilometerMile = '0.621371';
            $scope.postalRadiusUnit = $scope.kilometerMile;

            $scope.$watch('page', function (newPage, oldPage) {
               if (newPage != oldPage) {
                  $scope.search();
               }
            });

            locals.campaign = session.getCampaign();
            $scope.createInviteesModel = {
               campaigns: session.getCampaignsByBrand(locals.campaign.brandId),
               selectedCampaign: locals.campaign
            };
         },

         searchResults: function (response) {
            $scope.records = response.data;
            $scope.total = parseInt(response.headers("X-TotalRecords"));
         },

         getSearchArgs: function () {
            var sources = _.map(_.filter($scope.sources, function (s) {
               return s.selected;
            }), function (s) {
               return s.value;
            });

            var since = null;
            if ($scope.months) {
               since = moment().subtract($scope.months, 'months');
               since = utils.toServerDateTime(since);
            }

            var radius = null;
            if ($scope.postalCode && $scope.postalRadius) {
               radius = {
                  postalCode: $scope.postalCode,
                  radiusKm: Math.round($scope.postalRadius / $scope.postalRadiusUnit)
               };
            }

            var eventIds = null;
            if ($scope.selectedEventIds) {
               eventIds = $scope.selectedEventIds;
            }

            var surveyFilters = null;
            if ($scope.surveyFilters.length > 0) {
               surveyFilters = _.map($scope.surveyFilters, function (filter) {
                  return {
                     name: filter.surveyItem.key,
                     value: filter.surveyItemValue
                  };
               });
            }

            var locale = $scope.localeSelect != 'other' || '' ? $scope.localeSelect : null;
            if (!locale && $scope.localeOtherValue) {
               locale = $scope.localeOtherValue;
            }

            return {
               campaignId: locals.campaign.id,
               eventIds: eventIds,
               sources: sources,
               preRegDidAttend: $scope.sources.prereg.didAttend,
               attendedDidNotPreReg: $scope.sources.participant.didNotPreReg,
               inviteDidNotRsvp: $scope.sources.invitee.didNotRsvp,
               since: since,
               contactOptin: $scope.contactOptin,
               salesOptin: $scope.salesOptin,
               promoOptin: $scope.promoOptin,
               contestOptin: $scope.contestOptin,
               referrer: $scope.referrer,
               locale: locale,
               gender: $scope.gender,
               minAge: $scope.minAge,
               maxAge: $scope.maxAge,
               radius: radius,
               surveyFilters: surveyFilters
            };
         }
      };

      $scope.localeToggle = function () {
         if ($scope.localeSelect === 'other') {
            $scope.localeOther = true;
         } else {
            $scope.localeOther = false;
         }
      };

      $scope.getSurveyItemLabel = function (surveyItem) {
         return ['(' + surveyItem.key + ')', surveyItem.description].join(' ');
      };

      $scope.addSurveyFilter = function () {
         $scope.editSurveyFilter(null).result.then(function (filter) {
            $scope.surveyFilters.push(filter);
         });
      };

      $scope.editSurveyFilter = function (filter) {
         return $modal.open({
            templateUrl: 'survey-filter-modal.html',
            controller: 'SurveyFilterModalController',
            scope: $scope,
            resolve: {
               surveyItems: function () {
                  return surveyItemsApi.list(locals.campaign.brandId, true);
               },
               filter: function () {
                  return filter;
               }
            }
         });
      };

      $scope.removeSurveyFilter = function (index) {
         $scope.surveyFilters.splice(index, 1);
      };

      $scope.search = function () {
         var args = locals.getSearchArgs(),
            offset = ($scope.page - 1) * $scope.limit;

         if (args.sources.length === 0) {
            toast.error()
               .message('Select at least one source')
               .send();
            return;
         }

         loader.showSpinner();

         advSearchApi.search(args, offset, $scope.limit)
            .then(locals.searchResults)
            ['catch'](function (e) {
               toast.error()
                  .title('There was a problem performing the search.')
                  .message('Please take a screen capture and file a bug report.')
                  .send();
            })
            ['finally'](function () {
               loader.hide();
            });
      };

      $scope.download = function () {
         var args = locals.getSearchArgs();

         if (args.sources.length === 0) {
            toast.error()
               .message('Select at least one source')
               .send();
            return;
         }

         advSearchApi.download(args);
      };

      $scope.createInvitees = function () {
         var message = `${$scope.records.length} invitees will be created for ${$scope.createInviteesModel.selectedCampaign.name}. Are you sure you want to do this?`;

         dialogs.confirm(message).then(function () {
            loader.showSpinner();

            var args = locals.getSearchArgs(),
               campaignId = $scope.createInviteesModel.selectedCampaign.id,
               evt = $scope.createInviteesModel.selectedEvent,
               eventId = (evt) ? evt.id : null;

            advSearchApi.invitees(args, eventId, campaignId)
               .then(success, error);

            function success(response) {
               $scope.showCreateInviteesPanel = false;
               toast.success()
                  .message('The invitees have been successfully created')
                  .send();
               loader.hide();
            }

            function error(error) {
               toast.error()
                  .message('There was a problem creating invitees.')
                  .send();
               loader.hide();
            }
         });
      };

      locals.init();
   }
]);

e360.controller('SurveyFilterModalController', [
   '$scope',
   '$uibModalInstance',
   'surveyItemsApi',
   'surveyItems',
   'filter',

   function ($scope, $modalInstance, surveyItemsApi, surveyItems, filter) {
      var locals = {
         isBooleanType: function (item) {
            return item.type === 'Boolean';
         }
      };

      $scope.isEdit = (filter) ? true : false;
      $scope.model = {
         surveyItems: surveyItems,
         surveyItemChoices: null,
         selectedSurveyItem: ($scope.isEdit) ? filter.surveyItem : null,
         selectedSurveyItemValue: null
      };

      if ($scope.isEdit) {
         if (locals.isBooleanType(filter.surveyItem)) {
            $scope.model.selectedSurveyItemValue = (filter.surveyItemValue) ? 'true' : 'false';
         } else {
            $scope.model.selectedSurveyItemValue = filter.surveyItemValue;
         }
      }

      $scope.surveyItemSelectionDidChange = function () {
         $scope.model.selectedSurveyItemValue = null;
         $scope.model.surveyItemChoices = null;
         if ($scope.isOptionType()) {
            surveyItemsApi.get($scope.model.selectedSurveyItem.id).then(function (data) {
               $scope.model.surveyItemChoices = data.surveyItemChoices;
            });
         }
      };

      $scope.getSurveyItemChoiceLabel = function (surveyItemChoice) {
         return ['(' + surveyItemChoice.key + ')', surveyItemChoice.label].join(' ');
      };

      $scope.isOptionType = function () {
         if (!$scope.model.selectedSurveyItem) {
            return false;
         }
         var type = $scope.model.selectedSurveyItem.type;
         return type === 'Option' || type === 'Multioption';
      };

      $scope.isBooleanType = function () {
         return ($scope.model.selectedSurveyItem && locals.isBooleanType($scope.model.selectedSurveyItem));
      };

      $scope.isTextType = function () {
         return ($scope.model.selectedSurveyItem && $scope.model.selectedSurveyItem.type === 'Text');
      };

      $scope.done = function () {
         var surveyItemValue = $scope.model.selectedSurveyItemValue;

         if ($scope.isBooleanType()) {
            surveyItemValue = (surveyItemValue === 'true');
         }

         if (!filter) {
            filter = {};
         }

         filter.surveyItem = $scope.model.selectedSurveyItem;
         filter.surveyItemValue = surveyItemValue;

         $modalInstance.close(filter);
      };

      $scope.cancel = function () {
         $modalInstance.dismiss();
      };

   }
]);
